module.exports = __webpack_public_path__ + "img/intro_top.2e8f5651.jpg";